import React, { useEffect } from "react";
import CustomSlider from "../../components/CustomSlider/CustomSlider";
import "../../App.css";
import { useNavigate } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { Helmet } from "react-helmet-async";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

const fetchHighlightedProjects = async (apiToken) => {
  const response = await fetch(
    `${API_BASE_URL}/api/single-projects?populate=FeaturedImage&filters[Highlight][$eq]=true`,
    {
      headers: {
        Authorization: `Bearer ${apiToken}`,
      },
    }
  );
  const data = await response.json();

  return data.data
    .filter(
      (project) =>
        project.attributes.FeaturedImage &&
        project.attributes.FeaturedImage.data &&
        project.attributes.slug
    )
    .sort(
      (a, b) =>
        (a.attributes.HomePageOrder || 0) - (b.attributes.HomePageOrder || 0)
    );
};

export default function HomePage({
  apiToken,
  onNavigate,
  screenHeight,
  setSliderTheme,
  setIsHeaderVisible,
  screenSize,
}) {
  const navigate = useNavigate();

  // Todos os Hooks são chamados no topo, incondicionalmente
  const {
    data: projects = [],
    isLoading,
    error,
  } = useQuery({
    queryKey: ["highlighted-projects"],
    queryFn: () => fetchHighlightedProjects(apiToken),
    staleTime: 1000 * 60 * 60 * 24, // 24h
    cacheTime: 1000 * 60 * 60 * 24, // 24h em cache
  });

  useEffect(() => {
    // A lógica de redirecionamento é a primeira a ser verificada neste useEffect
    if (screenSize === "small" || screenSize === "medium") {
      navigate("/projects", { replace: true });
      return; // Importante: Sai do useEffect para não executar o resto do código da Home
    }
    // O restante do código só executa se não houver redirecionamento
    setSliderTheme("Light");
    setIsHeaderVisible(true);
  }, [screenSize, navigate, setSliderTheme, setIsHeaderVisible]); // Adicionei todas as dependências corretamente

  // Se a página está redirecionando, não renderiza nada do conteúdo principal.
  // Isso evita o "flash" da homepage.
  if (screenSize === "small" || screenSize === "medium") {
    return null; // Retorna null imediatamente se a condição de redirecionamento for verdadeira
  }


  if (isLoading) return <p></p>;
  if (error) return <p>Erro ao carregar projetos</p>;

  const slides = projects.map((project) => ({
    image: `${project.attributes.FeaturedImage.data.attributes.url}`,
    url: `/projects/${project.attributes.slug}`,
    title: project.attributes.Title
  }));

  console.log(slides);

  const ogImage =
    slides?.[0]?.image ||
    "https://productive-prosperity-58dbc90efe.media.strapiapp.com/SEINEDESIGN_hotel_flottant_paris_off_1_3296f3d699.jpg";
  const ogUrl =
    typeof window !== "undefined"
      ? window.location.href
      : "https://ronzatti.com/";

  return (
    <>
      <Helmet>
        <meta name="robots" content="index, follow" />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <meta property="og:type" content="website" />
        <title>Agence d'Architecture Flottante - Seine Design</title>
        <meta property="og:url" content={ogUrl} />
        <link rel="canonical" href={ogUrl} />
        <meta
          name="description"
          content="Seine Design : architecture flottante innovante par Gérard Ronzatti. Découvrez nos projets durables sur les voies navigáveis."
        />
        <meta
          property="og:title"
          content="Agence d'Architecture Flottante - Seine Design"
        />
        <meta
          property="og:description"
          content="Seine Design, leader français en architecture flottante, conçoit des solutions innovantes pour les voies navigáveis. Explorez nos projets duráveis e respectueux de l'environnement, dirigés par Gérard Ronzatti."
        />
        <meta property="og:image" content={ogImage} />
      </Helmet>
      <main className="homepage">
        <CustomSlider
          slides={slides}
          enableDrag={false}
          onNavigate={onNavigate}
          screenHeight={screenHeight}
        />
      </main>
    </>
  );
}